import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";

export interface IProductGroup {
  id: number
  code: string
  title: string
  status: number
  carLineId: number
  carLineTitle: string
  categoryCarId: number
  categoryTitle: string
}



//Danh sách nhóm sản phẩm
export const getListProductGroup = async (
  limit?: number, pageNumber?: number, search?: string, carLineId?: number,
  typeVehicleId?: number,
) => {
  const path = "vehicleGroup/listVehicleGroup"
  const params = {
    limit, pageNumber, search, carLineId,
    typeVehicleId,
  }
  const result: ResponseSuccessTotal<IProductGroup[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin nhóm sản phẩm
export const getInfoProductGroup = async (
  id: number) => {
  const path = "vehicleGroup/infoVehicleGroup"
  const params = {
    id
  }
  const result: ResponseSuccess<IProductGroup> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thêm mới nhóm sản phẩm
export const addProductGroup = async (
  code: string, title: string, carLineId: number, categoryCarId: number
) => {
  const url = `vehicleGroup/addVehicleGroup`;
  const params = {
    code, title, carLineId, categoryCarId
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa nhóm sản phẩm
export const editProductGroup = async (
  id: number, code: string, title: string, carLineId: number,
  categoryCarId: number
) => {
  const url = `vehicleGroup/editVehicleGroup`;
  const params = {
    id, code, title, carLineId, categoryCarId
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa nhóm sản phẩm
export const deleteProductGroup = async (
  id: number[]
) => {
  const url = `vehicleGroup/deleteVehicleGroup`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

export const updateActiveProductGroup = async (
  id: number) => {
  const path = "vehicleGroup/activeVehicleGroup"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};
